import type { DemoSlotsTrackerMetrics } from '../../model/demo-slot/interfaces'
import type { ApiCallbacks } from '@shared/api'

import { runApiGet } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

import { useDemoShiftControlStore } from '../../model/shift-control/store'

type SlotsTrackerMetricsApiOptions = ApiCallbacks<DemoSlotsTrackerMetrics>

export const useSlotsTrackerMetricsApi = async (options?: SlotsTrackerMetricsApiOptions): Promise<DemoSlotsTrackerMetrics | null> => {
  const demoShiftControlStore = useDemoShiftControlStore()
  const url = useAdminRoutes('admin.demo-slots.metrics')

  return runApiGet<DemoSlotsTrackerMetrics>(url, {
    setLoading: (loading) => demoShiftControlStore.setLoading(loading),
    handle: (response) => {
      const metrics: DemoSlotsTrackerMetrics | null = response?.data?.metrics || null
      demoShiftControlStore.setMetrics(metrics)
      return metrics
    },
    hooks: options,
  })
}
